// @ts-ignore
import laMeuse from '@/assets/icons/LaMeuseDragLocation.svg';
// @ts-ignore
import valleeSud from '@/assets/icons/ValleeSudDragLocation.svg';

export function debounce<Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number
): (...args: Params) => void {
  let timer: any;
  return (...args: Params) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
};

export const Uint8ArrayImage = (rgb: { r: number; g: number; b: number }) => {
  const width = 64; // The image will be 64 pixels square
  const bytesPerPixel = 4; // Each pixel is represented by 4 bytes: red, green, blue, and alpha.
  const data = new Uint8Array(width * width * bytesPerPixel);

  for (let x = 0; x < width; x++) {
    for (let y = 0; y < width; y++) {
      const offset = (y * width + x) * bytesPerPixel;
      data[offset + 0] = rgb.r; // red
      data[offset + 1] = rgb.g; // green
      data[offset + 2] = rgb.b; // blue
      data[offset + 3] = 255; // alpha
    }
  }

  return {
    width,
    height: width,
    data
  };
};

export const projectDefaultColor = () => {
  const defaultColor: Record<string, string> = {
    laMeuse: '#ea580c',
    valleeSud: '#01b6bc'
  };
  return defaultColor[process.env.VUE_APP_PROJECT];
};
export const projectDefaultTitle = () => {
  const defaultTitle: Record<string, string> = {
    laMeuse: 'La Meuse - Explorer',
    valleeSud: 'Vallée Sud - Explorer'
  };
  return defaultTitle[process.env.VUE_APP_PROJECT];
};
export const projectDefaultCities = () => {
  const defaultCities: any = {
    laMeuse: [
      { name: 'Verdun', coordinates: [5.38, 49.15], type: 'Verdun' },
      { name: 'Saint-Mihiel', coordinates: [5.54, 48.88], type: 'Saint' },
      { name: 'Commercy', coordinates: [5.58, 48.76], type: 'Commercy' },
      { name: 'Bar-le-Duc', coordinates: [5.15, 48.77], type: 'BarLeDuc' },
      { name: 'Ligny-en-Barrois', coordinates: [5.32, 48.68], type: 'Ligny' }
    ],
    valleeSud: [
      { name: 'Bourg-la-Reine', coordinates: [2.317, 48.7804], type: 'Bourg' },
      { name: 'Malakoff', coordinates: [2.2971725463867188, 48.81740483113745], type: 'Malakoff' },
      { name: 'Montrouge', coordinates: [2.3160552978515625, 48.81440938571626], type: 'Montrouge' },
      { name: 'Bagneux', coordinates: [2.3137515411376953, 48.7950477103721], type: 'Bagneux' },
      { name: 'Clamart', coordinates: [2.26318359375, 48.80030578049016], type: 'Clamart' },
      { name: 'Sceaux', coordinates: [2.2934389114379883, 48.77746026817414], type: 'Sceaux' },
      { name: 'Antony', coordinates: [2.2959280014038086, 48.75355748513624], type: 'Antony' },
      { name: 'Le Plessis-Robinson', coordinates: [2.261981964111328, 48.781108331129786], type: 'Robinson' },
      { name: 'Fontenay-aux-Roses', coordinates: [2.2870445251464844, 48.79111793253358], type: 'Fontenay' },
      { name: 'Châtillon', coordinates: [2.289705276489258, 48.79976869107526], type: 'Châtillon' },
      { name: 'Châtenay-Malabry', coordinates: [2.27816104888916, 48.7661184724023], type: 'Châtenay' }
    ]
  };
  return defaultCities[process.env.VUE_APP_PROJECT];
};
export const projectDefaultBoundingBox = () => {
  const defaultBoundingBox: any = {
    laMeuse: [4.951589, 48.36131, 5.7082980043213745, 49.638313180630554],
    valleeSud: [2.228391654789448, 48.73874425135152, 2.331564836204052, 48.82480083652752]
  };
  return defaultBoundingBox[process.env.VUE_APP_PROJECT];
};
export const projectDefaultDragIcon = () => {
  const defaultDragIcon: any = {
    laMeuse,
    valleeSud
  };
  return defaultDragIcon[process.env.VUE_APP_PROJECT];
};
export const projectDefaultMapView = () => {
  const defaultmapView: any = {
    laMeuse: {
      local: { center: [5.38, 48.95], zoom: 9 },
      extraRegional: { center: [5.3, 49.1], zoom: 5.5 }
    },
    valleeSud: {
      local: { center: [2.28, 48.78], zoom: 12 },
      extraRegional: { center: [-38.486706, 44.588567], zoom: 2.5 }
    }
  };
  return defaultmapView[process.env.VUE_APP_PROJECT];
};
